(() => {
  if (window.__NT_CART_DISCOUNT_LOADED__) return;

  window.__NT_CART_DISCOUNT_LOADED__ = true;


  function getRoot() {
    return window.Shopify?.routes?.root || '/';
  }


  function getDrawer() {
    return document.querySelector('cart-drawer');
  }


  function getAllDiscountApplications(cart) {
    const applications = [];


    /*
     * Cart-Level Discounts
     */
    (
      cart.cart_level_discount_applications || []
    ).forEach((application) => {

      if (application) {
        applications.push(application);
      }

    });


    /*
     * Line-Level Discounts
     *
     * Wichtig bei Rabattcodes, die nur bestimmte
     * Produkte rabattieren.
     */
    (cart.items || []).forEach((item) => {

      (
        item.line_level_discount_allocations || []
      ).forEach((allocation) => {

        if (allocation?.discount_application) {
          applications.push(
            allocation.discount_application
          );
        }

      });

    });


    return applications;
  }


  function getAppliedDiscountCodes(cart) {
    const applications =
      getAllDiscountApplications(cart);


    const codes = [];


    applications.forEach((application) => {

      if (
        application.type === 'discount_code' &&
        application.title
      ) {

        const title =
          application.title.trim();


        const alreadyExists =
          codes.some(
            (code) =>
              code.toUpperCase() ===
              title.toUpperCase()
          );


        if (!alreadyExists) {
          codes.push(title);
        }

      }

    });


    return codes;
  }


  function cartContainsCode(cart, code) {
    const wanted =
      code.trim().toUpperCase();


    return getAllDiscountApplications(cart)
      .some((application) => {

        return (
          application.title &&
          application.title
            .trim()
            .toUpperCase() === wanted
        );

      });
  }


  async function getCart() {
    const response =
      await fetch(
        `${getRoot()}cart.js`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );


    if (!response.ok) {
      throw new Error(
        'Warenkorb konnte nicht geladen werden.'
      );
    }


    return response.json();
  }


  function setMessage(text, error = false) {
    const message =
      document.querySelector(
        '[data-nt-discount-message]'
      );


    if (!message) return;


    message.textContent =
      text || '';


    message.classList.toggle(
      'is-error',
      error
    );


    message.classList.toggle(
      'is-success',
      !error && Boolean(text)
    );
  }


  function setApplyLoading(loading) {
    const button =
      document.querySelector(
        '[data-nt-discount-apply]'
      );


    if (!button) return;


    button.disabled =
      loading;


    button.textContent =
      loading
        ? 'Wird angewendet…'
        : 'Anwenden';
  }


  function renderAppliedDiscounts(cart) {
    const container =
      document.querySelector(
        '[data-nt-applied-discounts]'
      );


    if (!container) return;


    container.replaceChildren();


    const codes =
      getAppliedDiscountCodes(cart);


    if (!codes.length) {
      container.hidden = true;
      return;
    }


    container.hidden = false;


    codes.forEach((code) => {

      const chip =
        document.createElement('div');


      chip.className =
        'nt-cart-discount-chip';


      /*
       * Tag Icon
       */
      const icon =
        document.createElement('span');


      icon.className =
        'nt-cart-discount-chip__icon';


      icon.setAttribute(
        'aria-hidden',
        'true'
      );


      icon.innerHTML = `
        <svg viewBox="0 0 20 20">
          <path
            d="M3 4.5A1.5 1.5 0 0 1 4.5 3H10l7 7-7 7-7-7V4.5Zm4 1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
            fill="currentColor"
          ></path>
        </svg>
      `;


      /*
       * Code
       */
      const name =
        document.createElement('span');


      name.className =
        'nt-cart-discount-chip__name';


      name.textContent =
        code;


      /*
       * Remove Button
       */
      const remove =
        document.createElement('button');


      remove.type =
        'button';


      remove.className =
        'nt-cart-discount-chip__remove';


      remove.dataset.ntDiscountRemove =
        code;


      remove.setAttribute(
        'aria-label',
        `Rabattcode ${code} entfernen`
      );


      remove.textContent =
        '×';


      chip.append(
        icon,
        name,
        remove
      );


      container.appendChild(
        chip
      );

    });
  }


  function getSectionIds() {
    const drawer =
      getDrawer();


    if (
      drawer &&
      typeof drawer.getSectionsToRender ===
        'function'
    ) {

      return drawer
        .getSectionsToRender()
        .map(
          (section) =>
            section.id
        );
    }


    return [
      'cart-drawer',
      'cart-icon-bubble',
    ];
  }


  async function updateDiscountCodes(codes) {
    const drawer =
      getDrawer();


    const response =
      await fetch(
        `${getRoot()}cart/update.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          body: JSON.stringify({
            /*
             * Shopify erwartet mehrere Codes
             * komma-getrennt.
             *
             * [] wird dadurch zu ""
             * und entfernt die Codes.
             */
            discount:
              codes.join(','),

            sections:
              getSectionIds(),

            sections_url:
              window.location.pathname,
          }),
        }
      );


    if (!response.ok) {
      throw new Error(
        'Rabattcode konnte nicht aktualisiert werden.'
      );
    }


    const cart =
      await response.json();


    /*
     * Drawer mit den von Shopify neu
     * berechneten Preisen rendern.
     */
    if (
      drawer &&
      typeof drawer.renderContents ===
        'function' &&
      cart.sections
    ) {

      drawer.renderContents(
        cart
      );

    }


    return cart;
  }


  function wait(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}


async function waitForDiscountCode(code) {
  let latestCart = null;

  /*
   * Shopify benötigt manchmal einen kurzen Moment,
   * bis der angewendete Rabattcode in /cart.js
   * als Discount Application auftaucht.
   */
  for (let attempt = 0; attempt < 5; attempt++) {

    if (attempt > 0) {
      await wait(150);
    }

    latestCart = await getCart();

    if (
      cartContainsCode(
        latestCart,
        code
      )
    ) {
      return latestCart;
    }
  }

  return latestCart;
}


  async function applyDiscountCode(code) {
  code =
    code.trim();


  if (!code) {
    setMessage(
      'Bitte gib einen Rabattcode ein.',
      true
    );

    return;
  }


  setApplyLoading(true);
  setMessage('');


  try {

    /*
     * Bereits vorhandene Rabattcodes holen.
     */
    const currentCart =
      await getCart();


    const codes =
      getAppliedDiscountCodes(
        currentCart
      );


    const alreadyExists =
      codes.some(
        (existingCode) =>
          existingCode.toUpperCase() ===
          code.toUpperCase()
      );


    if (!alreadyExists) {
      codes.push(code);
    }


    /*
     * Rabatt bei Shopify setzen.
     */
    await updateDiscountCodes(
      codes
    );


    /*
     * WICHTIG:
     * Nicht die direkte update.js-Antwort prüfen.
     *
     * Stattdessen kurz warten und Shopify
     * über /cart.js erneut abfragen.
     */
    const verifiedCart =
      await waitForDiscountCode(
        code
      );


    if (
      !verifiedCart ||
      !cartContainsCode(
        verifiedCart,
        code
      )
    ) {

      setMessage(
        'Rabattcode ist ungültig oder kann nicht mit diesem Warenkorb kombiniert werden.',
        true
      );

      return;
    }


    /*
     * Code sofort anzeigen.
     * Kein Reload mehr notwendig.
     */
    renderAppliedDiscounts(
      verifiedCart
    );


    const input =
      document.querySelector(
        '[data-nt-discount-input]'
      );


    if (input) {
      input.value = '';
    }


    setMessage(
      'Rabattcode angewendet.'
    );


  } catch (error) {

    console.error(
      '[NeverTap Discount]',
      error
    );


    setMessage(
      'Rabattcode konnte nicht angewendet werden.',
      true
    );


  } finally {

    setApplyLoading(false);

  }
}


  async function removeDiscountCode(code) {
  try {

    const cart =
      await getCart();


    const remainingCodes =
      getAppliedDiscountCodes(cart)
        .filter(
          (existingCode) =>
            existingCode.toUpperCase() !==
            code.toUpperCase()
        );


    await updateDiscountCodes(
      remainingCodes
    );


    /*
     * Shopify kurz Zeit zum Aktualisieren geben.
     */
    await wait(150);


    const updatedCart =
      await getCart();


    renderAppliedDiscounts(
      updatedCart
    );


    setMessage('');


  } catch (error) {

    console.error(
      '[NeverTap Discount Remove]',
      error
    );


    setMessage(
      'Rabattcode konnte nicht entfernt werden.',
      true
    );

  }
}


  async function refreshAppliedDiscounts() {
    try {

      const cart =
        await getCart();


      renderAppliedDiscounts(
        cart
      );

    } catch (error) {

      console.error(
        '[NeverTap Discount Refresh]',
        error
      );

    }
  }


  /*
   * Rabattcode anwenden
   */
  document.addEventListener(
    'submit',
    (event) => {

      const form =
        event.target.closest(
          '[data-nt-discount-form]'
        );


      if (!form) return;


      event.preventDefault();


      const input =
        form.querySelector(
          '[data-nt-discount-input]'
        );


      applyDiscountCode(
        input?.value || ''
      );

    }
  );


  /*
   * Rabattcode entfernen
   */
  document.addEventListener(
    'click',
    (event) => {

      const removeButton =
        event.target.closest(
          '[data-nt-discount-remove]'
        );


      if (!removeButton) return;


      event.preventDefault();


      const code =
        removeButton.dataset
          .ntDiscountRemove;


      if (!code) return;


      removeDiscountCode(
        code
      );

    }
  );


  /*
   * Bei Seitenaufruf vorhandene Codes
   * aus Shopify laden.
   */
  document.addEventListener(
    'DOMContentLoaded',
    () => {

      refreshAppliedDiscounts();


      /*
       * Auch nach Add-to-Cart /
       * Mengenänderungen aktualisieren.
       */
      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !==
          'undefined'
      ) {

        subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          () => {

            window.setTimeout(
              refreshAppliedDiscounts,
              150
            );

          }
        );

      }

    }
  );

})();